define('adminLmbAnalyzersView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!adminLmbAnalyzersListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var LmbAnalyzerListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'lmbAnalyzersListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteLmbAnalyzer: '.delete-lmbanalyzer-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteLmbAnalyzer': 'onDeleteLmbAnalyzer'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {type: 'lmbanalyzers'};

            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteLmbAnalyzer: function(event){
            this.trigger('lmbanalyzer:delete', $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('common.code'),
                        name: 'code',
                        classes: 'lmbanalyzer-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'code'
                    }, {
                        label: _.i18n('lmbanalyzer.refMbAModel'),
                        name: 'refMbAModel.code',
                        classes: 'lmbanalyzer-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'refMbAModel.code'
                    }, {
                        label: _.i18n('common.serialNb'),
                        name: 'serialNb',
                        classes: 'lmbanalyzer-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'serialNb'
                    }, {
                        label: _.i18n('common.location'),
                        name: 'location',
                        classes: 'lmbanalyzer-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'location'
                    }, {
                        label: _.i18n('common.description'),
                        name: 'description',
                        classes: 'lmbanalyzer-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'description'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-lmbanalyzer-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            var route = App.getCurrentRoute() ===  'admin/lmbanalyzers' ?
                                App.getCurrentRoute() : 'admin/lmbanalyzers/' + App.getCurrentRoute();
                            App.navigate(route + '/' + rowId, {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = LmbAnalyzerListView;
});
